const DEFAULT_PAGE_SIZE = 12;

export { DEFAULT_PAGE_SIZE };

export default { DEFAULT_PAGE_SIZE };
